/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Visitor } from '../models/Visitor';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class VisitorService {
    /**
     * Get a list of visitors
     * @param workspaceId Workspace ID required
     * @param requestBody
     * @param limit Limit of objects to get
     * @param offset skip number of objects to get in list
     * @returns Visitor Successfully retrieved visitors
     * @throws ApiError
     */
    public static postVisitorList(
        workspaceId: string,
        requestBody: {
            start_date: string;
            end_date: string;
        },
        limit?: number,
        offset?: number,
    ): CancelablePromise<Visitor> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/visitor/list',
            query: {
                'workspace_id': workspaceId,
                'limit': limit,
                'offset': offset,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
}
